export { default } from 'cccisd-game-zoou-ic0';
